export const MenuItems = [{
    title: 'Virginia Department of Social Services',
    desc: "Web Content Coordinator",
    time: "April 2022 - Current",
    img:'/images/vdss-logo.jpeg',
    cName: 'exp-item'
}]